import React, { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

import { Loader } from '@components/atoms'
import { sharedAPi } from '@services/ShareAPI'

import { NotebooksStyles } from './style'

const { container } = NotebooksStyles

export const Shared = () => {
	const [searchParams] = useSearchParams()
	const navigation = useNavigate()

	const [sharedFilter, { isSuccess: isSuccessSharedFilter }] =
		sharedAPi.useSharedFilterMutation()

	const [sharedFolderFilter, { isSuccess: isSuccessSharedFolderFilter }] =
		sharedAPi.useSharedFolderFilterMutation()

	const [sharedNotebook, { isSuccess: isSuccessSharedNotebook }] =
		sharedAPi.useSharedNotebookMutation()

	const [sharedFolderNotebook, { isSuccess: isSuccessSharedFolderNotebook }] =
		sharedAPi.useSharedFolderNotebookMutation()

	useEffect(() => {
		if (searchParams.get('type') && searchParams.get('id')) {
			if (searchParams.get('type') === 'filter') {
				sharedFilter({ id: Number(searchParams.get('id')) })
			} else if (searchParams.get('type') === 'folderFilter') {
				sharedFolderFilter({ id: Number(searchParams.get('id')) })
			} else if (searchParams.get('type') === 'notebook') {
				sharedNotebook({ id: Number(searchParams.get('id')) })
			} else if (searchParams.get('type') === 'folderNotebook') {
				sharedFolderNotebook({ id: Number(searchParams.get('id')) })
			}
		}
	}, [
		searchParams,
		sharedFilter,
		sharedFolderFilter,
		sharedFolderNotebook,
		sharedNotebook,
	])

	useEffect(() => {
		if (
			isSuccessSharedFilter ||
			isSuccessSharedNotebook ||
			isSuccessSharedFolderFilter ||
			isSuccessSharedFolderNotebook
		) {
			if (
				searchParams.get('type') === 'filter' ||
				searchParams.get('type') === 'folderFilter'
			) {
				navigation('/filtros-salvos')
			} else if (
				searchParams.get('type') === 'notebook' ||
				searchParams.get('type') === 'folderNotebook'
			) {
				navigation('/cadernos')
			}
		}
	}, [
		isSuccessSharedFilter,
		isSuccessSharedFolderFilter,
		isSuccessSharedNotebook,
		isSuccessSharedFolderNotebook,
		navigation,
		searchParams,
	])

	return (
		<div className={container()}>
			<div>
				<Loader />
			</div>
		</div>
	)
}
